import { drilldownData, ModuleFields } from "~/Utils/drilldownData";

export const mapFields = (data: ModuleFields[]) =>
  data.map(({ fieldName, placeholder, name, formType, validation, className, usedFileType, options }) => ({
    name: name,
    type: formType,
    label: fieldName,
    placeholder: placeholder,
    validation: validation,
    className: className,
    usedFileType: usedFileType,
    options: options
  }));

export const fields: any = {
  airlineServices: drilldownData["airlineServices"].map(
    ({ fieldName, placeholder, name, formType, validation, className, usedFileType }: ModuleFields) => ({
      name: name,
      type: formType,
      label: fieldName,
      placeholder: placeholder,
      validation: validation,
      className: className,
      usedFileType: usedFileType
    })
  ),
  airportConsultancy: drilldownData["airportConsultancy"].map(
    ({ fieldName, placeholder, name, formType, validation, className, usedFileType }: ModuleFields) => ({
      name: name,
      type: formType,
      label: fieldName,
      placeholder: placeholder,
      validation: validation,
      className: className,
      usedFileType: usedFileType
    })
  ),
  airlineIncentivesPageContent: drilldownData["airlineIncentivesPageContent"].map(
    ({ fieldName, placeholder, name, formType, validation, className, usedFileType }: ModuleFields) => ({
      name: name,
      type: formType,
      label: fieldName,
      placeholder: placeholder,
      validation: validation,
      className: className,
      usedFileType: usedFileType
    })
  ),
  airportPlaningAndDesign:drilldownData["airportPlaningAndDesign"].map(
    ({ fieldName, placeholder, name, formType, validation, className, usedFileType }: ModuleFields) => ({
      name: name,
      type: formType,
      label: fieldName,
      placeholder: placeholder,
      validation: validation,
      className: className,
      usedFileType: usedFileType
    })
  ),
  airportDevelopment:drilldownData["airportDevelopment"].map(
    ({ fieldName, placeholder, name, formType, validation, className, usedFileType }: ModuleFields) => ({
      name: name,
      type: formType,
      label: fieldName,
      placeholder: placeholder,
      validation: validation,
      className: className,
      usedFileType: usedFileType
    })
  ),
  airportOperationsAndAirportSystems:drilldownData["airportOperationsAndAirportSystems"].map(
    ({ fieldName, placeholder, name, formType, validation, className, usedFileType }: ModuleFields) => ({
      name: name,
      type: formType,
      label: fieldName,
      placeholder: placeholder,
      validation: validation,
      className: className,
      usedFileType: usedFileType
    })
  ),
  overseasInvestments:drilldownData["overseasInvestments"].map(
    ({ fieldName, placeholder, name, formType, validation, className, usedFileType }: ModuleFields) => ({
      name: name,
      type: formType,
      label: fieldName,
      placeholder: placeholder,
      validation: validation,
      className: className,
      usedFileType: usedFileType
    })
  ),
  commercialLeasingOpportunitiesList: mapFields(drilldownData['commercialLeasingOpportunitiesList']),
  othersList: mapFields(drilldownData['othersList']),
  serviceOutletList: mapFields(drilldownData['serviceOutletList']),
  foodAndBeverageList: mapFields(drilldownData['foodAndBeverageList']),
  retailOutletList: mapFields(drilldownData['retailOutletList']),
  airlineServicesFacilities: mapFields(drilldownData['airlineServicesFacilities']),
  airlineIncentivesPageHeading: mapFields(drilldownData['airlineIncentivesPageHeading']),
  airlineServicesFacilitiesPageHeading: mapFields(drilldownData['airlineServicesFacilitiesPageHeading']),
  airportConsultancyPageHeading: mapFields(drilldownData['airportConsultancyPageHeading']),
  commercialLeasingOpportunitiesPageHeading:mapFields(drilldownData['commercialLeasingOpportunitiesPageHeading']),
  airportConsultancyNextPage: mapFields(drilldownData['airportConsultancyNextPage']),
  airlineIncentivesNextPage: mapFields(drilldownData['airlineIncentivesNextPage']),
  airlineServicesFacilitiesNextPage: mapFields(drilldownData['airlineServicesFacilitiesNextPage'])
};
